module.exports = __webpack_public_path__ + "img/P150T_weapon_138.019ec654.png";